import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Api_Url } from "../../../utils/ApiUrl";
import Modal from "react-bootstrap/Modal";
// import axios from 'axios';
// import { Api_Url } from '../../../utils/ApiUrl';
import { useHistory } from "react-router-dom";
import Web3 from "web3";
import { toast } from "react-toastify";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import { useDetectClickOutside } from "react-detect-click-outside";
import { CopyToClipboard } from "react-copy-to-clipboard";
import moment from "moment";
import DataTable from "./DataTable/DataTable";
import "./institution.scss";

const InstitutionalStat = ({
  user,
  setUser,
  usdPrice,
  tomiPrice,
  btcPrice,
}) => {
  // console.log("users data", user)
  const [topTenApiCalled, setTopTenApiCalled] = useState(false);
  const [transactionApiCalled, setTransactionApiCalled] = useState(false);

  const [codeDataCall, setCodeDataCall] = useState();
  const tok = localStorage?.getItem("accessToken");
  const [data, setData] = useState([]);
  const [totalT, setTotalT] = useState(0);
  const [welcome, setwelcome] = useState();
  const [purchases, setPurchases] = useState(null);
  const [earnings, setEarnings] = useState(null);
  const [netRevenue, setnetRevenue] = useState(null);
  // const [usdPrice, setUsdPrice] = useState(0);
  // console.log("sdfdsfsdf", usdPrice)
  // const [tomiPrice, setchange24hr1] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [transactionsData, setTransactionsData] = useState([]);
  const [userselectdate, setuserselectdate] = useState(false);
  const [pc, setPC] = useState(0);
  const [pmc, setPMC] = useState(0);
  const [nrc, setNRC] = useState(0);
  const [lc, setLC] = useState(0);
  const [dpc, setDPC] = useState(0);
  const [lec, setLEC] = useState(0);
  const [a, seta] = useState(0);
  const [m, setm] = useState(0);
  const [s, sets] = useState(0);
  const [g, setg] = useState(0);
  const [mm, setmm] = useState(0);
  const [ss, setss] = useState(0);
  const [gg, setgg] = useState(0);
  const [pee, setPEE] = useState(0);
  const [peu, setPEU] = useState(0);
  const [pdp, setPDP] = useState(0);
  const [ind, setIND] = useState(0);
  const [dt, setDT] = useState(0);
  const [totalleader, settotalleader] = useState(0);
  const [activeleader, setactiveleader] = useState(0);
  const [round, setRound] = useState("");
  const [dataTime, setDataTime] = useState("1");

  const [dops, setDops] = useState(null);
  const [dopPrice, setDopPrice] = useState(0);
  const [search, setSearch] = useState("");
  const [topLeaderSearch, setTopLeaderSearch] = useState("");

  const [showtext, SetShowtext] = useState(false);

  const [orderField, setOrderField] = useState("transactionTime");
  const [orderDirection, setOrderDirection] = useState("-1");
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState([]);
  const [topTenLeaders, setTopTenLeaders] = useState([]);
  const [timeFilter, setTimeFilter] = useState("1");
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const [showcalendar, setShowCalendar] = useState(false);

  const [Users1, setUsers1] = useState(null);
  const [Users2, setUsers2] = useState(null);
  const [Users3, setUsers3] = useState(null);
  const [Users4, setUsers4] = useState(null);

  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [alllset, setalllset] = useState("1");
  const [show, setShow] = useState(false);
  const [agents, setAgents] = useState([]);
  const [name, setName] = useState("");
  const [role, setRole] = useState(null);
  const [addr, setAddr] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [show1, setShow1] = useState(false);

  const [insName, setInsName] = useState("");
  const [insWallet, setInsWallet] = useState("");
  const [insEmail, setInsEmail] = useState("");
  const [insPrice, setInsPrice] = useState("");

  const handleClose1 = () => {
    setName("");
    setAddr("");
    setEmail("");
    setRole(null);
    setShow1(false);
  };

  const [activeTab, setActiveTab] = useState("home-tab");
  // const [tomiPrice, setTomiPrice] = useState("");

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  function isValidEmail(email) {
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
  }

  function isAddressValid(address) {
    return Web3.utils.isAddress(address);
  }

  // const getTomiPrice = async () => {
  //   try {
  //     const response = await axios.get(
  //       `https://api.coingecko.com/api/v3/simple/price`,
  //       {
  //         params: {
  //           ids: "tomiNet",
  //           vs_currencies: "usd",
  //         },
  //       }
  //     );

  //     const data = response?.data;
  //     const priceInUSD = data["tominet"]?.usd;

  //     setTomiPrice(priceInUSD);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     // throw error;
  //   }
  // };

  useEffect(() => {
    GetTopTenLeaders();
  }, [activeTab, topLeaderSearch, timeFilter]);

  const GetTopTenLeaders = async () => {
    // if (account) {

    let date = null;
    let date1 = null;
    if (timeFilter == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (timeFilter == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (timeFilter == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (timeFilter == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    let url = `${Api_Url}/institutions/top-institutions?limit=10`;
    if (url != null) {
      let dynamicQuery = url;

      if (topLeaderSearch) {
        dynamicQuery += `&search=${topLeaderSearch}`;
      }
      if (timeFilter) {
        dynamicQuery += `&startDate=${date}&endDate=${date1}`;
      }
      url = dynamicQuery;
      var config = {
        method: "get",
        url: url,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };

      axios(config)
        .then(function (response) {
          setTopTenLeaders(response?.data?.data);
          setTopTenApiCalled(true);
        })
        .catch(function (error) {
          setTopTenApiCalled(true);

          console.log(error);
        });
    }
    // }
  };

  const GetTopTenLeaders1 = async (times) => {
    // if (account) {
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      let url = `${Api_Url}/institutions/top-institutions?limit=10`;
      if (url != null) {
        let dynamicQuery = url;

        if (topLeaderSearch) {
          dynamicQuery += `&search=${topLeaderSearch}`;
        }
        dynamicQuery += `&startDate=${date}&endDate=${date1}`;

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            setTopTenLeaders(response?.data?.data);
            setTopTenApiCalled(true);
          })
          .catch(function (error) {
            setTopTenApiCalled(true);

            console.log(error);
          });
      }
    }
    // }
  };

  const AddInstitution = () => {
    if (insName?.length > 2) {
      if (Web3.utils.isAddress(insWallet)) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(insEmail)) {
          if (parseFloat(insPrice) > 0) {
            setLoader(true);
            setError("");
            const val = localStorage.getItem("accessToken");
            let data = JSON.stringify({
              name: insName,
              walletAddress: insWallet,
              email: insEmail,
              dopPrice: insPrice,
            });
            let config = {
              method: "post",
              url: `${Api_Url}/institutions`,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${val}`,
              },
              data: data,
            };
            axios
              .request(config)
              .then((response) => {
                setLoader(false);
                setInsEmail("");
                setInsName("");
                setInsPrice("");
                setInsWallet("");
                handleClose1();
                setShow2(true);
              })
              .catch((error) => {
                setError(error?.response?.data?.message);
                setLoader(false);
              });
          } else {
            setError("Institution dop price should be greater than 0!");
          }
        } else {
          setError("Institution email address is incorrect!");
        }
      } else {
        setError("Institution wallet address is incorrect!");
      }
    } else {
      setError("Institution name must be at least of length 3!");
    }
  };

  const SetPriceDOP = (val) => {
    let valu = parseFloat(val);
    if (valu > 0) {
      setInsPrice(parseFloat(valu));
    } else {
      setInsPrice(0);
    }
  };

  function convertToTitleCase(input) {
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );

      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }

  // useEffect(() => {
  //   getTomiPrice();
  //   axios
  //     .get("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD")
  //     .then((res) => {
  //       setUsdPrice(res?.data?.USD);
  //       // setEthUsd(res.data);
  //     });
  // }, []);

  const handlePageChange = (e) => {
    const selectedPage = e.selected;
    setPage(selectedPage);
  };

  const getTransactionsData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/institutions/all-transactions?limit=2000&offset=1`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    let dynamicQuery = config.url;

    if (search) {
      dynamicQuery += `&by=${search}`;
    }

    if (orderField) {
      dynamicQuery += `&orderField=${orderField}&orderDirection=${orderDirection}`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.transactions);
        setTransactions(res?.data?.data?.transactions);
        setPageCount(res?.data?.data?.pages);
        setTransactionApiCalled(true);
        setLoader(false);
      })
      .catch(function (error) {
        setTransactionApiCalled(true);

        setLoader(false);
      });
  };

  const [adminobj, setadminobj] = useState();
  const [adminobjjj, setadminobjjj] = useState();

  // console.log("value ",user)

  useEffect(() => {
    // GetAllRounds();
    // GetMyData();
    if (usdPrice) {
      getTransactionsData();
      // getTotalList();
    }
  }, [usdPrice, user, search, orderField, orderDirection]);

  useEffect(() => {
    GetDashboardDataMyUsers1("1");
  }, [usdPrice]);

  // User gode mega leader super data upper stats
  const GetDashboardDataMyUsers = (times) => {
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      var config = {
        method: "get",
        url: `${Api_Url}/institutions/stats?startDate=${date}&&endDate=${date1}`,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };
      axios(config)
        .then(function (response) {
          setadminobjjj(response?.data?.data);
          let data = response?.data?.data;
          // No. of Institutions changes
          let inst = 0;
          inst = data?.institutions - data?.oldInstitutions;
          if (data?.oldInstitutions > 0) {
            inst = (inst / data?.oldInstitutions) * 100;
          } else {
            inst = inst * 100;
          }
          setLC(inst);
          // Number of Purchases changes
          let oldNum = 0;
          let newNum = 0;
          let oldDop = 0;
          let newDop = 0;
          if (data?.purchasesAndDopPurchased?.length > 0) {
            newNum = data?.purchasesAndDopPurchased[0]?.totalPurchases;
            newDop = data?.purchasesAndDopPurchased[0]?.totalDopPurchased;
          }
          if (data?.oldPurchasesAndDopPurchased?.length > 0) {
            oldNum = data?.oldPurchasesAndDopPurchased[0]?.totalPurchases;
            oldDop = data?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased;
          }
          let nums = newNum - oldNum;
          let dops = newDop - oldDop;
          if (oldNum > 0) {
            nums = (nums / oldNum) * 100;
            dops = dops / oldDop;
          } else {
            nums = nums * 100;
            dops = dops * 100;
          }
          setPC(nums);
          setDPC(dops);

          // Purchased amount changes
          let purAmc = null;
          let oldPurAmc = null;
          if (data?.purchasedAmount?.length > 0) {
            let usdt = 0;
            let eth = 0;
            data?.purchasedAmount[0]
              ? data.purchasedAmount[0]._id == "ETH"
                ? (eth = data?.purchasedAmount[0].purchasedAmount)
                : (eth = eth)
              : (eth = eth);
            data?.purchasedAmount[1]
              ? data?.purchasedAmount[1]._id == "ETH"
                ? (eth = data?.purchasedAmount[1].purchasedAmount)
                : (eth = eth)
              : (eth = eth);

            data?.purchasedAmount[0]
              ? data?.purchasedAmount[0]._id == "USDT"
                ? (usdt = data.purchasedAmount[0].purchasedAmount)
                : (usdt = usdt)
              : (usdt = usdt);
            data?.purchasedAmount[1]
              ? data.purchasedAmount[1]._id == "USDT"
                ? (usdt = data.purchasedAmount[1].purchasedAmount)
                : (usdt = usdt)
              : (usdt = usdt);
            purAmc = {
              eth: eth,
              usdt: usdt,
            };
          }
          if (data?.oldPurchasedAmount?.length > 0) {
            let usdt = 0;
            let eth = 0;
            data?.oldPurchasedAmount[0]
              ? data.oldPurchasedAmount[0]._id == "ETH"
                ? (eth = data?.oldPurchasedAmount[0].purchasedAmount)
                : (eth = eth)
              : (eth = eth);
            data?.oldPurchasedAmount[1]
              ? data?.oldPurchasedAmount[1]._id == "ETH"
                ? (eth = data?.oldPurchasedAmount[1].purchasedAmount)
                : (eth = eth)
              : (eth = eth);

            data?.oldPurchasedAmount[0]
              ? data?.oldPurchasedAmount[0]._id == "USDT"
                ? (usdt = data.oldPurchasedAmount[0].purchasedAmount)
                : (usdt = usdt)
              : (usdt = usdt);
            data?.oldPurchasedAmount[1]
              ? data.oldPurchasedAmount[1]._id == "USDT"
                ? (usdt = data.oldPurchasedAmount[1].purchasedAmount)
                : (usdt = usdt)
              : (usdt = usdt);
            oldPurAmc = {
              eth: eth,
              usdt: usdt,
            };
          }
          // let value = response?.data?.data;
          // console.log("sdfsfsdfsdfsdfdsfsdfdf", value)
          // setPDP(value?.purchasesAndDopPurchased);
          // setPEU(value?.purchasedAndEarningsUsdt);
          // setPEE(value?.purchasedAndEarningsEth);
          // setIND(value?.inDirectSales);
          // setDT(value?.directSales);
          // setPMC(value?.myPurchasesAmountChange);
          // setLEC(value?.myEarningsChange);
          // setgg(value?.leaders);
          // setmm(value?.megas);
          // setss(value?.supers);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const GetDashboardDataMyUsers1 = (alll) => {
    // console.log("state one day")
    setuserselectdate(true);
    let date = null;
    let date1 = null;
    if (alll == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    if (date && date1) {
      var config = {
        method: "get",
        url: `${Api_Url}/institutions/stats?startDate=${date}&&endDate=${date1}`,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };
      axios(config)
        .then(function (response) {
          // console.log("responce ++++++++++++++ 1 Day",response)
          setadminobjjj(response?.data?.data);
          let data = response?.data?.data;
          // No. of Institutions changes
          let inst = 0;
          inst = data?.institutions - data?.oldInstitutions;
          if (data?.oldInstitutions > 0) {
            inst = (inst / data?.oldInstitutions) * 100;
          } else {
            inst = inst * 100;
          }
          setLC(inst);
          // Number of Purchases changes
          let oldNum = 0;
          let newNum = 0;
          let oldDop = 0;
          let newDop = 0;
          if (data?.purchasesAndDopPurchased?.length > 0) {
            newNum = data?.purchasesAndDopPurchased[0]?.totalPurchases;
            newDop = data?.purchasesAndDopPurchased[0]?.totalDopPurchased;
          }
          if (data?.oldPurchasesAndDopPurchased?.length > 0) {
            oldNum = data?.oldPurchasesAndDopPurchased[0]?.totalPurchases;
            oldDop = data?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased;
          }
          let nums = newNum - oldNum;
          let dops = newDop - oldDop;
          if (oldNum > 0) {
            nums = (nums / oldNum) * 100;
            dops = dops / oldDop;
          } else {
            nums = nums * 100;
            dops = dops * 100;
          }
          setPC(nums);
          setDPC(dops);
          // Purchased amount changes
          let purAmc = null;
          let oldPurAmc = null;
          if (data?.purchasedAmount?.length > 0) {
            let usdt = 0;
            let eth = 0;
            data?.purchasedAmount[0]
              ? data.purchasedAmount[0]._id == "ETH"
                ? (eth = data?.purchasedAmount[0].purchasedAmount)
                : (eth = eth)
              : (eth = eth);
            data?.purchasedAmount[1]
              ? data?.purchasedAmount[1]._id == "ETH"
                ? (eth = data?.purchasedAmount[1].purchasedAmount)
                : (eth = eth)
              : (eth = eth);

            data?.purchasedAmount[0]
              ? data?.purchasedAmount[0]._id == "USDT"
                ? (usdt = data.purchasedAmount[0].purchasedAmount)
                : (usdt = usdt)
              : (usdt = usdt);
            data?.purchasedAmount[1]
              ? data.purchasedAmount[1]._id == "USDT"
                ? (usdt = data.purchasedAmount[1].purchasedAmount)
                : (usdt = usdt)
              : (usdt = usdt);
            purAmc = {
              eth: eth,
              usdt: usdt,
            };
          }
          if (data?.oldPurchasedAmount?.length > 0) {
            let usdt = 0;
            let eth = 0;
            data?.oldPurchasedAmount[0]
              ? data.oldPurchasedAmount[0]._id == "ETH"
                ? (eth = data?.oldPurchasedAmount[0].purchasedAmount)
                : (eth = eth)
              : (eth = eth);
            data?.oldPurchasedAmount[1]
              ? data?.oldPurchasedAmount[1]._id == "ETH"
                ? (eth = data?.oldPurchasedAmount[1].purchasedAmount)
                : (eth = eth)
              : (eth = eth);

            data?.oldPurchasedAmount[0]
              ? data?.oldPurchasedAmount[0]._id == "USDT"
                ? (usdt = data.oldPurchasedAmount[0].purchasedAmount)
                : (usdt = usdt)
              : (usdt = usdt);
            data?.oldPurchasedAmount[1]
              ? data.oldPurchasedAmount[1]._id == "USDT"
                ? (usdt = data.oldPurchasedAmount[1].purchasedAmount)
                : (usdt = usdt)
              : (usdt = usdt);
            oldPurAmc = {
              eth: eth,
              usdt: usdt,
            };
          }
          let totalOldVal = 0;
          let totalVal = 0;
          if (purAmc) {
            totalVal = purAmc.eth * usdPrice + purAmc.usdt;
          }
          if (oldPurAmc) {
            totalOldVal = oldPurAmc.eth * usdPrice + oldPurAmc.usdt;
          }

          let valu = 0;
          valu = totalVal - totalOldVal;
          if (totalOldVal > 0) {
            valu = (valu / totalOldVal) * 100;
          } else {
            valu = valu * 100;
          }
          setNRC(valu);

          // let value = response?.data?.data;
          // console.log("sdfsfsdfsdfsdfdsfsdfdf", value)
          // setPDP(value?.purchasesAndDopPurchased);
          // setPEU(value?.purchasedAndEarningsUsdt);
          // setPEE(value?.purchasedAndEarningsEth);
          // setIND(value?.inDirectSales);
          // setDT(value?.directSales);
          // setPC(value?.myPurchasesChange);
          // setPMC(value?.myPurchasesAmountChange);
          // setLEC(value?.myEarningsChange);
          // setgg(value?.leaders);
          // setmm(value?.megas);
          // setss(value?.supers);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const GetDashboardDataMyUsers11 = () => {
    // console.log("state one day")
    setuserselectdate(true);
    var config = {
      method: "get",
      url: `${Api_Url}/institutions/stats`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        setadminobjjj(response?.data?.data);
        let data = response?.data?.data;
        // No. of Institutions changes
        let inst = 0;
        inst = data?.institutions - data?.oldInstitutions;
        if (data?.oldInstitutions > 0) {
          inst = (inst / data?.oldInstitutions) * 100;
        } else {
          inst = inst * 100;
        }
        setLC(inst);
        // Number of Purchases changes
        let oldNum = 0;
        let newNum = 0;
        let oldDop = 0;
        let newDop = 0;
        if (data?.purchasesAndDopPurchased?.length > 0) {
          newNum = data?.purchasesAndDopPurchased[0]?.totalPurchases;
          newDop = data?.purchasesAndDopPurchased[0]?.totalDopPurchased;
        }
        if (data?.oldPurchasesAndDopPurchased?.length > 0) {
          oldNum = data?.oldPurchasesAndDopPurchased[0]?.totalPurchases;
          oldDop = data?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased;
        }
        let nums = newNum - oldNum;
        let dops = newDop - oldDop;
        if (oldNum > 0) {
          nums = (nums / oldNum) * 100;
          dops = dops / oldDop;
        } else {
          nums = nums * 100;
          dops = dops * 100;
        }
        setPC(nums);
        setDPC(dops);
        // Purchased amount changes
        let purAmc = null;
        let oldPurAmc = null;
        if (data?.purchasedAmount?.length > 0) {
          let usdt = 0;
          let eth = 0;
          data?.purchasedAmount[0]
            ? data.purchasedAmount[0]._id == "ETH"
              ? (eth = data?.purchasedAmount[0].purchasedAmount)
              : (eth = eth)
            : (eth = eth);
          data?.purchasedAmount[1]
            ? data?.purchasedAmount[1]._id == "ETH"
              ? (eth = data?.purchasedAmount[1].purchasedAmount)
              : (eth = eth)
            : (eth = eth);

          data?.purchasedAmount[0]
            ? data?.purchasedAmount[0]._id == "USDT"
              ? (usdt = data.purchasedAmount[0].purchasedAmount)
              : (usdt = usdt)
            : (usdt = usdt);
          data?.purchasedAmount[1]
            ? data.purchasedAmount[1]._id == "USDT"
              ? (usdt = data.purchasedAmount[1].purchasedAmount)
              : (usdt = usdt)
            : (usdt = usdt);
          purAmc = {
            eth: eth,
            usdt: usdt,
          };
        }
        if (data?.oldPurchasedAmount?.length > 0) {
          let usdt = 0;
          let eth = 0;
          data?.oldPurchasedAmount[0]
            ? data.oldPurchasedAmount[0]._id == "ETH"
              ? (eth = data?.oldPurchasedAmount[0].purchasedAmount)
              : (eth = eth)
            : (eth = eth);
          data?.oldPurchasedAmount[1]
            ? data?.oldPurchasedAmount[1]._id == "ETH"
              ? (eth = data?.oldPurchasedAmount[1].purchasedAmount)
              : (eth = eth)
            : (eth = eth);

          data?.oldPurchasedAmount[0]
            ? data?.oldPurchasedAmount[0]._id == "USDT"
              ? (usdt = data.oldPurchasedAmount[0].purchasedAmount)
              : (usdt = usdt)
            : (usdt = usdt);
          data?.oldPurchasedAmount[1]
            ? data.oldPurchasedAmount[1]._id == "USDT"
              ? (usdt = data.oldPurchasedAmount[1].purchasedAmount)
              : (usdt = usdt)
            : (usdt = usdt);
          oldPurAmc = {
            eth: eth,
            usdt: usdt,
          };
        }
        // console.log("responce ++++++++++++++ 1 Day",response)
        // let value = response?.data?.data;
        // console.log("sdfsfsdfsdfsdfdsfsdfdf", value)
        // setPDP(value?.purchasesAndDopPurchased);
        // setPEU(value?.purchasedAndEarningsUsdt);
        // setPEE(value?.purchasedAndEarningsEth);
        // setIND(value?.inDirectSales);
        // setDT(value?.directSales);
        // setPC(value?.myPurchasesChange);
        // setPMC(value?.myPurchasesAmountChange);
        // setLEC(value?.myEarningsChange);
        // setgg(value?.leaders);
        // setmm(value?.megas);
        // setss(value?.supers);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const GetMyData = async () => {
    const tok = localStorage?.getItem("accessToken");
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url}/institutions/stats`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        setuserselectdate(false);
        let value = response?.data?.data;
        // console.log("sdfsfsdfsdfsdfdsfsdfdf", value)
        setPDP(value?.purchasesAndDopPurchased);
        setPEU(value?.purchasedAndEarningsUsdt);
        setPEE(value?.purchasedAndEarningsEth);
        setIND(value?.inDirectSales);
        setDT(value?.directSales);
        setPC(value?.myPurchasesChange);
        setPMC(value?.myPurchasesAmountChange);
        setLC(value?.myLeadersChange);
        setDPC(value?.myDopPurchasedChange);
        setLEC(value?.myEarningsChange);
        setgg(value?.leaders);
        setmm(value?.megas);
        setss(value?.supers);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          history.push("/login");
        }

        console.log(error);
      });
    // }
  };

  // const closeDropdown = () => {
  //   // console.log("ddddddd")
  //   setShowCalendar(!showcalendar);
  // };
  // const ref = useDetectClickOutside({ onTriggered: closeDropdown });
  // console.log("ddddddd", showcalendar);

  const [copy, setCopy] = useState(false);
  const textCopiedFun2 = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };

  const [hoveredElements, setHoveredElements] = useState({
    icon1: false,
    icon2: false,
    icon3: false,
    icon4: false,
    icon5: false,
    icon6: false,
  });
  const handleMouseEnter = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: true });
    const isMobileView = window.innerWidth < 768;
    if (isMobileView) {
      setTimeout(() => {
        setHoveredElements({ ...hoveredElements, [element]: false });
      }, 5000);
    }
  };
  const handleMouseLeave = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: false });
  };

  return (
    <>
      <section className="institution-dashbaord">
        <div className="custom-container">
          {/* {user?.role == "god_agent" ||
                        user?.role == "agent" ||
                        user?.role == "mega_agent" ||
                        user?.role == "super_agent" ? (
                        <h3 className="welcomesss">
                            Hi {welcome ? welcome : ""} {user ? user?.name : ""} Your code is:
                            {copy ? (
                                <span className="adadasdasdasdasdasdsad">
                                    {" "}
                                    {user?.accessCode}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        className=""
                                    >
                                        <path
                                            d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                                            stroke="green"
                                            stroke-width="2.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                                            stroke="green"
                                            stroke-width="2.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </span>
                            ) : (
                                <>
                                    {user?.accessCode && (
                                        <CopyToClipboard
                                            text={user?.accessCode}
                                            onCopy={textCopiedFun2}
                                        >
                                            <span className="adadasdasdasdasdasdsad">
                                                {user?.accessCode}
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                    className=""
                                                >
                                                    <path
                                                        d="M13 10.5V13.5C13 16 12 17 9.5 17H6.5C4 17 3 16 3 13.5V10.5C3 8 4 7 6.5 7H9.5C12 7 13 8 13 10.5Z"
                                                        stroke="white"
                                                        stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M17 6.5V9.5C17 12 16 13 13.5 13H12.7143V10.7857C12.7143 8.28571 11.7143 7.28571 9.21429 7.28571H7V6.5C7 4 8 3 10.5 3H13.5C16 3 17 4 17 6.5Z"
                                                        stroke="white"
                                                        stroke-width="1.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                        </CopyToClipboard>
                                    )}
                                </>
                            )}
                        </h3>
                    ) : (
                        ""
                    )}
                    {user?.role == "admin" ? (
                        <h3 className="welcomesss">Hi {welcome ? welcome : ""}</h3>
                    ) : (
                        ""
                    )} */}

          <div className="mainbuttonsss">
            <div className="main-heading m-0">
              <h6>Institutions Stats</h6>
            </div>
            <button className="gusvtsvtvtsvxs" onClick={() => setShow1(true)}>
              Add Institution
            </button>

            <div className="parent-twice-custom">
              {/* <div class="dropdown">
                                <button
                                    class="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {round == ""
                                        ? "All Rounds"
                                        : round == "1"
                                            ? "Round 1"
                                            : round == "2"
                                                ? "Round 2"
                                                : round == "3"
                                                    ? "Round 3"
                                                    : round == "4"
                                                        ? "Round 4"
                                                        : ""}{" "}
                                    <img
                                        src="\assets\arrow-down.svg"
                                        alt="img"
                                        className="img-fluid"
                                    />
                                </button>
                                <ul class="dropdown-menu">
                                    <li>
                                        <a
                                            class="dropdown-item"
                                            href="#"
                                            onClick={() => {
                                                setRound("");
                                            }}
                                        >
                                            All Rounds
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="dropdown-item"
                                            href="#"
                                            onClick={() => {
                                                setRound("1");
                                            }}
                                        >
                                            Round 1
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="dropdown-item"
                                            href="#"
                                            onClick={() => {
                                                setRound("2");
                                            }}
                                        >
                                            Round 2
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="dropdown-item"
                                            href="#"
                                            onClick={() => {
                                                setRound("3");
                                            }}
                                        >
                                            Round 3
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="dropdown-item"
                                            href="#"
                                            onClick={() => {
                                                setRound("4");
                                            }}
                                        >
                                            Round 4
                                        </a>
                                    </li>
                                </ul>
                            </div> */}
              <div className="custom-tab-bar">
                <a
                  onClick={() => {
                    setalllset("1");

                    GetDashboardDataMyUsers1("1");
                    setTimeFilter("1");
                  }}
                  className={alllset == "1" ? "active" : "noactive"}
                >
                  1D
                </a>
                <a
                  onClick={() => {
                    setalllset("seven");
                    GetDashboardDataMyUsers1("seven");
                    setTimeFilter("seven");
                  }}
                  className={alllset == "seven" ? "active" : "noactive"}
                >
                  7D
                </a>
                <a
                  onClick={() => {
                    setalllset("month");
                    GetDashboardDataMyUsers1("month");
                    setTimeFilter("month");
                  }}
                  className={alllset == "month" ? "active" : "noactive"}
                >
                  1M
                </a>
                <a
                  onClick={() => {
                    setalllset("year");
                    GetDashboardDataMyUsers1("year");
                    setTimeFilter("year");
                  }}
                  className={alllset == "year" ? "active" : "noactive"}
                >
                  1Y
                </a>
                <a
                  onClick={() => {
                    setalllset("all");
                    GetDashboardDataMyUsers11();
                    setTimeFilter("");
                  }}
                  className={alllset == "all" ? "active" : "noactive"}
                >
                  All
                </a>
                <a onClick={() => setShowCalendar(!showcalendar)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M17.1667 3.56V2C17.1667 1.59 16.8267 1.25 16.4167 1.25C16.0067 1.25 15.6667 1.59 15.6667 2V3.5H9.16673V2C9.16673 1.59 8.82673 1.25 8.41673 1.25C8.00673 1.25 7.66673 1.59 7.66673 2V3.56C4.96673 3.81 3.65673 5.42 3.45673 7.81C3.43673 8.1 3.67673 8.34 3.95673 8.34H20.8767C21.1667 8.34 21.4067 8.09 21.3767 7.81C21.1767 5.42 19.8667 3.81 17.1667 3.56Z"
                      fill="white"
                    />
                    <path
                      d="M20.4167 9.84009H4.41675C3.86675 9.84009 3.41675 10.2901 3.41675 10.8401V17.0001C3.41675 20.0001 4.91675 22.0001 8.41675 22.0001H16.4167C19.9167 22.0001 21.4167 20.0001 21.4167 17.0001V10.8401C21.4167 10.2901 20.9667 9.84009 20.4167 9.84009ZM9.62675 18.2101C9.57675 18.2501 9.52675 18.3001 9.47675 18.3301C9.41675 18.3701 9.35675 18.4001 9.29675 18.4201C9.23675 18.4501 9.17675 18.4701 9.11675 18.4801C9.04675 18.4901 8.98675 18.5001 8.91675 18.5001C8.78675 18.5001 8.65675 18.4701 8.53675 18.4201C8.40675 18.3701 8.30675 18.3001 8.20675 18.2101C8.02675 18.0201 7.91675 17.7601 7.91675 17.5001C7.91675 17.2401 8.02675 16.9801 8.20675 16.7901C8.30675 16.7001 8.40675 16.6301 8.53675 16.5801C8.71675 16.5001 8.91675 16.4801 9.11675 16.5201C9.17675 16.5301 9.23675 16.5501 9.29675 16.5801C9.35675 16.6001 9.41675 16.6301 9.47675 16.6701C9.52675 16.7101 9.57675 16.7501 9.62675 16.7901C9.80675 16.9801 9.91675 17.2401 9.91675 17.5001C9.91675 17.7601 9.80675 18.0201 9.62675 18.2101ZM9.62675 14.7101C9.43675 14.8901 9.17675 15.0001 8.91675 15.0001C8.65675 15.0001 8.39675 14.8901 8.20675 14.7101C8.02675 14.5201 7.91675 14.2601 7.91675 14.0001C7.91675 13.7401 8.02675 13.4801 8.20675 13.2901C8.48675 13.0101 8.92675 12.9201 9.29675 13.0801C9.42675 13.1301 9.53675 13.2001 9.62675 13.2901C9.80675 13.4801 9.91675 13.7401 9.91675 14.0001C9.91675 14.2601 9.80675 14.5201 9.62675 14.7101ZM13.1267 18.2101C12.9367 18.3901 12.6767 18.5001 12.4167 18.5001C12.1567 18.5001 11.8967 18.3901 11.7067 18.2101C11.5267 18.0201 11.4167 17.7601 11.4167 17.5001C11.4167 17.2401 11.5267 16.9801 11.7067 16.7901C12.0767 16.4201 12.7567 16.4201 13.1267 16.7901C13.3067 16.9801 13.4167 17.2401 13.4167 17.5001C13.4167 17.7601 13.3067 18.0201 13.1267 18.2101ZM13.1267 14.7101C13.0767 14.7501 13.0267 14.7901 12.9767 14.8301C12.9167 14.8701 12.8567 14.9001 12.7967 14.9201C12.7367 14.9501 12.6767 14.9701 12.6167 14.9801C12.5467 14.9901 12.4867 15.0001 12.4167 15.0001C12.1567 15.0001 11.8967 14.8901 11.7067 14.7101C11.5267 14.5201 11.4167 14.2601 11.4167 14.0001C11.4167 13.7401 11.5267 13.4801 11.7067 13.2901C11.7967 13.2001 11.9067 13.1301 12.0367 13.0801C12.4067 12.9201 12.8467 13.0101 13.1267 13.2901C13.3067 13.4801 13.4167 13.7401 13.4167 14.0001C13.4167 14.2601 13.3067 14.5201 13.1267 14.7101ZM16.6267 18.2101C16.4367 18.3901 16.1767 18.5001 15.9167 18.5001C15.6567 18.5001 15.3967 18.3901 15.2067 18.2101C15.0267 18.0201 14.9167 17.7601 14.9167 17.5001C14.9167 17.2401 15.0267 16.9801 15.2067 16.7901C15.5767 16.4201 16.2567 16.4201 16.6267 16.7901C16.8067 16.9801 16.9167 17.2401 16.9167 17.5001C16.9167 17.7601 16.8067 18.0201 16.6267 18.2101ZM16.6267 14.7101C16.5767 14.7501 16.5267 14.7901 16.4767 14.8301C16.4167 14.8701 16.3567 14.9001 16.2967 14.9201C16.2367 14.9501 16.1767 14.9701 16.1167 14.9801C16.0467 14.9901 15.9767 15.0001 15.9167 15.0001C15.6567 15.0001 15.3967 14.8901 15.2067 14.7101C15.0267 14.5201 14.9167 14.2601 14.9167 14.0001C14.9167 13.7401 15.0267 13.4801 15.2067 13.2901C15.3067 13.2001 15.4067 13.1301 15.5367 13.0801C15.7167 13.0001 15.9167 12.9801 16.1167 13.0201C16.1767 13.0301 16.2367 13.0501 16.2967 13.0801C16.3567 13.1001 16.4167 13.1301 16.4767 13.1701C16.5267 13.2101 16.5767 13.2501 16.6267 13.2901C16.8067 13.4801 16.9167 13.7401 16.9167 14.0001C16.9167 14.2601 16.8067 14.5201 16.6267 14.7101Z"
                      fill="white"
                    />
                  </svg>
                </a>
                {/* {showcalendar && ( */}
                {showcalendar && (
                  <div className="cal set-custom-calendar-div">
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => {
                        GetDashboardDataMyUsers([item.selection]);
                        GetTopTenLeaders1([item.selection]);
                      }}
                      moveRangeOnFirstSelection={false}
                      ranges={state}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="bottom-cards">
            <div className="single-card">
              <img
                src="\assets\dashboard\noofpurchases.svg"
                alt="img"
                className="img-fluid"
              />
              <p>Number of Purchases</p>
              {adminobjjj?.purchasesAndDopPurchased?.length > 0 ? (
                <h6>
                  {adminobjjj?.purchasesAndDopPurchased[0]?.totalPurchases}
                  <span
                    className={pc > 0 ? "green-text ms-2" : "red-text ms-2"}
                  >
                    {pc ? pc.toFixed(1) + "% " : ""}
                  </span>
                </h6>
              ) : (
                <h6>0</h6>
              )}
            </div>
            <div className="single-card">
              <img
                src="\assets\dashboard\doppurchases.svg"
                alt="img"
                className="img-fluid"
              />
              <p>DOP Purchased</p>
              {adminobjjj?.purchasesAndDopPurchased?.length > 0 ? (
                <h6>
                  {parseInt(
                    adminobjjj?.purchasesAndDopPurchased[0]?.totalDopPurchased?.toFixed(
                      2
                    )
                  ).toLocaleString("en-US")}{" "}
                  &nbsp;DOP
                  <span
                    className={dpc > 0 ? "green-text ms-2" : "red-text ms-2"}
                  >
                    {dpc ? dpc.toFixed(1) + "% " : ""}
                  </span>
                </h6>
              ) : (
                <h6>0.00 DOP</h6>
              )}
            </div>
            <div className="single-card">
              <img
                src="\assets\dashboard\purchasedamount.svg"
                alt="img"
                className="img-fluid"
              />
              <p>Purchased Amount</p>
              {tomiPrice && usdPrice && adminobjjj ? (
                <h6 className="datahead">
                  {adminobjjj?.purchasedAmount &&
                  adminobjjj?.purchasedAmount?.length > 0
                    ? "~$" +
                      parseFloat(
                        (
                          usdPrice *
                            (adminobjjj?.purchasedAmount &&
                            adminobjjj?.purchasedAmount?.length > 0 &&
                            adminobjjj?.purchasedAmount[0]?._id == "ETH"
                              ? adminobjjj?.purchasedAmount[0]?.purchasedAmount
                              : adminobjjj?.purchasedAmount &&
                                adminobjjj?.purchasedAmount?.length > 0 &&
                                adminobjjj?.purchasedAmount[1]?._id == "ETH"
                              ? adminobjjj?.purchasedAmount[1]?.purchasedAmount
                              : adminobjjj?.purchasedAmount &&
                                adminobjjj?.purchasedAmount?.length > 0 &&
                                adminobjjj?.purchasedAmount[2]?._id == "ETH"
                              ? adminobjjj?.purchasedAmount[2]?.purchasedAmount
                              : 0) +
                          (adminobjjj?.purchasedAmount &&
                          adminobjjj?.purchasedAmount?.length > 0 &&
                          adminobjjj?.purchasedAmount[0]?._id == "USDT"
                            ? adminobjjj?.purchasedAmount[0]?.purchasedAmount
                            : adminobjjj?.purchasedAmount &&
                              adminobjjj?.purchasedAmount?.length > 0 &&
                              adminobjjj?.purchasedAmount[1]?._id == "USDT"
                            ? adminobjjj?.purchasedAmount[1]?.purchasedAmount
                            : adminobjjj?.purchasedAmount &&
                              adminobjjj?.purchasedAmount?.length > 0 &&
                              adminobjjj?.purchasedAmount[2]?._id == "USDT"
                            ? adminobjjj?.purchasedAmount[2]?.purchasedAmount
                            : 0) +
                          tomiPrice *
                            (adminobjjj?.purchasedAmount &&
                            adminobjjj?.purchasedAmount?.length > 0 &&
                            adminobjjj?.purchasedAmount[0]?._id == "TOMI"
                              ? adminobjjj?.purchasedAmount[0]?.purchasedAmount
                              : adminobjjj?.purchasedAmount &&
                                adminobjjj?.purchasedAmount?.length > 0 &&
                                adminobjjj?.purchasedAmount[1]?._id == "TOMI"
                              ? adminobjjj?.purchasedAmount[1]?.purchasedAmount
                              : adminobjjj?.purchasedAmount &&
                                adminobjjj?.purchasedAmount?.length > 0 &&
                                adminobjjj?.purchasedAmount[2]?._id == "TOMI"
                              ? adminobjjj?.purchasedAmount[2]?.purchasedAmount
                              : 0)
                        )?.toFixed(4)
                      ).toLocaleString("en-US")
                    : 0}

                  <span
                    className={nrc > 0 ? "green-text ms-2" : "red-text ms-2"}
                  >
                    {nrc ? nrc.toFixed(1) + "% " : ""}
                  </span>
                </h6>
              ) : (
                <h6 className="datahead">~$0.00 USD</h6>
              )}

              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {adminobjjj?.purchasedAmount &&
                  adminobjjj?.purchasedAmount?.length > 0 &&
                  adminobjjj?.purchasedAmount[0]?._id == "ETH"
                    ? adminobjjj?.purchasedAmount[0]?.purchasedAmount
                    : adminobjjj?.purchasedAmount &&
                      adminobjjj?.purchasedAmount[1]?._id == "ETH"
                    ? adminobjjj?.purchasedAmount[1]?.purchasedAmount
                    : adminobjjj?.purchasedAmount &&
                      adminobjjj?.purchasedAmount[2]?._id == "ETH"
                    ? adminobjjj?.purchasedAmount[2]?.purchasedAmount
                    : 0}{" "}
                  ETH
                </p>
                <p className="uni-text">
                  <span></span>
                  {adminobjjj?.purchasedAmount &&
                  adminobjjj?.purchasedAmount?.length > 0 &&
                  adminobjjj?.purchasedAmount[0]?._id == "USDT"
                    ? adminobjjj?.purchasedAmount[0]?.purchasedAmount
                    : adminobjjj?.purchasedAmount &&
                      adminobjjj?.purchasedAmount[1]?._id == "USDT"
                    ? adminobjjj?.purchasedAmount[1]?.purchasedAmount
                    : adminobjjj?.purchasedAmount &&
                      adminobjjj?.purchasedAmount[2]?._id == "USDT"
                    ? adminobjjj?.purchasedAmount[2]?.purchasedAmount
                    : 0}{" "}
                  USDT
                </p>
                <p className="uni-text">
                  <span></span>
                  {adminobjjj?.purchasedAmount &&
                  adminobjjj?.purchasedAmount?.length > 0 &&
                  adminobjjj?.purchasedAmount[0]?._id == "TOMI"
                    ? adminobjjj?.purchasedAmount[0]?.purchasedAmount
                    : adminobjjj?.purchasedAmount &&
                      adminobjjj?.purchasedAmount[1]?._id == "TOMI"
                    ? adminobjjj?.purchasedAmount[1]?.purchasedAmount
                    : adminobjjj?.purchasedAmount &&
                      adminobjjj?.purchasedAmount[2]?._id == "TOMI"
                    ? adminobjjj?.purchasedAmount[2]?.purchasedAmount
                    : 0}{" "}
                  TOMI
                </p>
              </div>
            </div>
            <div className="single-card  noofleaders-card ordersetsm2">
              <img
                src="\assets\dashboard\noofinstitution.svg"
                alt="img"
                className="img-fluid"
              />
              <p>No. of Institutions/Active Institutions</p>
              <div
                className="twice-textbtn"
                onClick={() => SetShowtext(!showtext)}
              >
                <h6>
                  {adminobjjj?.institutions ? adminobjjj?.institutions : 0} /{" "}
                  {adminobjjj?.activeInstitutions
                    ? adminobjjj?.activeInstitutions
                    : 0}
                  <span
                    className={lc > 0 ? "green-text ms-2" : "red-text ms-2"}
                  >
                    {lc ? lc.toFixed(1) + "% " : ""}
                  </span>
                </h6>
              </div>
            </div>
          </div>
          <DataTable
            setSearch={setSearch}
            setTopLeaderSearch={setTopLeaderSearch}
            user={user}
            getTransactionsData={getTransactionsData}
            usdPrice={usdPrice}
            transactions={transactions}
            setOrderDirection={setOrderDirection}
            setOrderField={setOrderField}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            topTenLeaders={topTenLeaders}
            topTenApiCalled={topTenApiCalled}
            transactionApiCalled={transactionApiCalled}
          />
        </div>
      </section>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Institution</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <div className="option-field">
              <div className="material-textfield">
                <input
                  value={insName}
                  onChange={(e) => setInsName(e.target.value)}
                  type="text"
                  placeholder="Enter Institution’s Name"
                />
                <label>Institution’s Name</label>
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  value={insWallet}
                  onChange={(e) => setInsWallet(e.target.value)}
                  type="text"
                  placeholder="Enter Institution’s Wallet Address"
                />
                <label>Institution’s Wallet Address</label>
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  value={insEmail}
                  onChange={(e) => setInsEmail(e.target.value)}
                  type="text"
                  placeholder="Enter Institution’s Email Address"
                />
                <label>Institution’s Email Address</label>
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  value={parseFloat(insPrice)}
                  onChange={(e) => SetPriceDOP(e.target.value)}
                  type="number"
                  placeholder="0.00"
                />
                <label>DOP Price</label>
              </div>
            </div>
          </div>
          <p
            style={{
              color: "red",
              textAlign: "center",
              marginTop: 15,
              marginBottom: 15,
            }}
          >
            {error}
          </p>
          <div className="twice-btn">
            <button
              onClick={() => {
                handleClose1();
              }}
              className="btn-cancel"
            >
              Back
            </button>
            <button onClick={() => AddInstitution()} className="btn-add">
              {loader ? "Adding..." : "Add"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Institution</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <h6>Institution has been added</h6>
          </div>
          <div className="twice-btn">
            <button
              onClick={() => handleClose2()}
              className="btn-add"
              style={{ flex: "auto" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InstitutionalStat;
